import { StyledHeader } from "./header.style";

export const Header = () => {
  return (
    <>
      <StyledHeader>КАЛЯНДАР ЗНАМЯНАЛЬНЫХ І ПАМЯТНЫХ ДАТ</StyledHeader>
    </>
  );
};
